export default __webpack_public_path__ + "static/media/articles-main-sm.289e4f97.jpg";